<span *ngFor="let breadcrumb of breadCrumbs">{{breadcrumb}}</span>
<span></span>
